export default __webpack_public_path__ + "static/media/congratulations.2c4dfc39.png";